import React from 'react'

interface DownloadIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const DownloadIcon: React.FC<DownloadIconProps> = ({
  color = '#888',
  gradient,
  width = 18,
  height = 17,
  alt = 'Download icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 18 17'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M8.182 16.067c.244.244.64.244.884 0l3.977-3.978a.625.625 0 1 0-.883-.883l-2.91 2.91V3.625a.625.625 0 1 0-1.25 0v10.491l-2.911-2.91a.625.625 0 1 0-.884.883zM16 3.625a.625.625 0 1 0 1.25 0v-3A.625.625 0 0 0 16.625 0h-16A.625.625 0 0 0 0 .625v3a.625.625 0 1 0 1.25 0V1.25H16z'
        clipRule='evenodd'
      ></path>
    </svg>
  )
}

export default DownloadIcon
